import { Component, OnInit } from '@angular/core';
import { Step } from 'src/app/core/dtos/step';
import { PageStepEnum, StepProgressService } from 'src/app/core/services/step-progress.service';

@Component({
  selector: 'app-batch-registration-select-sitting',
  templateUrl: './batch-registration-select-sitting.component.html',
  styleUrls: ['./batch-registration-select-sitting.component.scss']
})
export class BatchRegistrationSelectSittingComponent implements OnInit {
  steps: Step[];

  constructor(
    private stepProgressService: StepProgressService
  ) {
    this.steps = this.stepProgressService.getSteps(PageStepEnum.SittingSelection);
  }

  ngOnInit(): void {
  }

}
